<template>
 <div class="manager">
    <slider animation="fade" :control-btn="false">
       <slider-item><img src="@/assets/images/zhaopinbanner.jpg" height="100%"></slider-item>
    </slider>
    <div class="module grow">
      <div class="title">成长晋升</div>
    </div>
    <div class="tabs">
      <div class="contentWidth clearfix">
        <div class="item recruitment" v-bind:class="{ active: activeId==0 }" v-on:click="tabShow(0)">
          客户经理
        </div>
        <div class="item agent" v-bind:class="{ active: activeId==1 }" v-on:click="tabShow(1)">
          区域经理
        </div>
        <div class="item partner" v-bind:class="{ active: activeId==2 }" v-on:click="tabShow(2)">
          大区经理
        </div>
      </div>
    </div>
    <div class="module">
      <div class="contentWidth tabContent" id='tabContent'>
        <div class="tabItem clearfix" v-show="showId==0">
         <div class="fleft">
            <img src="@/assets/images/kehujingli_ICON.png"  width="250"/>
            <h1 class="title">职位年薪</h1>
            <span class="info">8-15万</span>
            <h1 class="title">招聘人数</h1>
            <span class="info">不限</span>
            <h1 class="title">发布日期</h1>
            <span class="info">2018年1月22日</span>
         </div>
         <div class="fright">
            <h1 class="title">客户经理</h1>
            <table class="detail">
              <tr>
                <td class="subTitle">薪资结构</td>
                <td>底薪3200+绩效800+奖金+超额提成</td>
              </tr>
              <tr>
                <td class="subTitle">岗位职责</td>
                <td>
                  1. 招募县级代理，完成公司下达的各项业绩指标<br/>
                  2. 驱动县代进行终端门店开发，并监督录入董妈咪系统<br/>
                  3. 调动县代业务人员及相关资源进行终端门店布建及营销活动的执行<br/>
                  4. 终端产品培训活动的需求反馈及组织<br/>
                  5. 辖区空白市场终端门店开发及客情维护<br/>
                  6. 配合集团进行终端门店.市场竞品等信息的收集及调研反馈<br/>
                  7. 培训县代业务人员使用羊村系统工具</td>
              </tr>
              <tr>
                <td class="subTitle">任职资格</td>
                <td>
                  1. 沟通能力较强，有一定应变能力<br/>
                  2. 能够调动客户/代理商资源<br/>
                  3. 擅长维护客情<br/>
                  4. 一年以上母婴行业.快速消费品行业营销经验，乳品类优先
                </td>
              </tr>
              <tr>
                <td class="subTitle">晋升标准</td>
                <td>
                  1. 晋升周期：3个月（非自然）<br/>
                  2. 门店开发指标＞35家<br/>
                  3. 半年业绩＞50万<br/>
                  4. 招募或培养至少一名客户经理
                </td>
              </tr>
            </table>
         </div>
        </div>
        <div class="tabItem clearfix" v-show="showId==1">
          <div class="fleft">
            <img src="@/assets/images/daqujingli_icon.png"  width="250"/>
            <h1 class="title">职位年薪</h1>
            <span class="info">12-20万</span>
            <h1 class="title">招聘人数</h1>
            <span class="info">不限</span>
            <h1 class="title">发布日期</h1>
            <span class="info">2018年1月22日</span>
         </div>
         <div class="fright">
            <h1 class="title">区域经理</h1>
            <table class="detail">
              <tr>
                <td class="subTitle">薪资结构</td>
                <td>底薪5000+绩效1000+奖金+提成</td>
              </tr>
              <tr>
                <td class="subTitle">岗位职责</td>
                <td>
                  1. 市场布局及开发，并完成公司下达的各项业绩指标（回款/门店数）<br/>
                  2. 负责辖区团队建设及管理，持续挖掘区域人员.构架.服务团队建设<br/>
                  3. 合理分配市场费用并制定辖区内终端门店管理运营办法（陈列布建政策价格体系等）<br/>
                  4. 收集辖区市场行情研究反馈，总结归纳区域市场各项策略落地实施的方案效果评估等<br/>
                  5. 为羊村战略决策提供数据依据<br/>
                </td>
              </tr>
              <tr>
                <td class="subTitle">任职资格</td>
                <td>
                  1. 具有良好的市场分析.营销推广能力，沟通能力强.问题解决能力<br/>
                  2. 具有一定的团队管理及协调能力<br/>
                  3. 具有区域市场（市级及以上）的规划及统筹执行能力<br/>
                  4. 掌握1个地市及以上母婴渠道资源信息，并能快速完成转化
                </td>
              </tr>
              <tr>
                <td class="subTitle">晋升标准</td>
                <td>
                  1. 晋升周期：半年（非自然）<br/>
                  2. 门店开发指标＞100家<br/>
                  3. 半年业绩＞600万<br/>
                  4. 招募或培养至少2名区域经理<br/>
                  5. 市场运营：费效比/人效比/品牌运作/市场运作综合评估
                </td>
              </tr>
            </table>
         </div>
        </div>
        <div class="tabItem clearfix" v-show="showId==2">
          <div class="fleft">
            <img src="@/assets/images/quyujingli_ICON.png"  width="250"/>
            <h1 class="title">职位年薪</h1>
            <span class="info">20-50万+股份/期权</span>
            <h1 class="title">招聘人数</h1>
            <span class="info">不限</span>
            <h1 class="title">发布日期</h1>
            <span class="info">2018年1月22日</span>
         </div>
         <div class="fright">
            <h1 class="title">大区经理</h1>
            <table class="detail">
              <tr>
                <td class="subTitle">薪资结构</td>
                <td>底薪7000+绩效3000+提成+奖金</td>
              </tr>
              <tr>
                <td class="subTitle">岗位职责</td>
                <td>
                  1. 持续寻找资源，对辖区市场进行布局及规划<br/>
                  2. 持续进行人才体系搭建及团队日常管理<br/>
                  3. 羊村各项业绩指标达成<br/>
                  4. 市场费用监控及使用<br/>
                  5. 羊村战略执行落地<br/>
                  6. 制定区域特性的营销运营方案<br/>
                  7. 总结模式优化业务流程，并形成一套可复制运营体系<br/>
                  8. 能主动协调外部及集团内部各种资源为辖区服务
                </td>
              </tr>
              <tr>
                <td class="subTitle">任职资格</td>
                <td>
                  1. 总结模式优化业务流程的能力<br/>
                  2. 成本管控能力，费效比<br/>
                  3. 团队管理及人才培养能力<br/>
                  4. 具有良好的渠道体系化布局建设能力；<br/>
                  5. 掌握1个省区及以上母婴渠道资源信息并能快速完成转化；<br/>
                  6. 战略理解及快速执行能力<br/>
                  7. 有资源协调及调动能力
                </td>
              </tr>
              <tr>
                <td class="subTitle">晋升标准</td>
                <td>
                  1. 晋利润考核达标<br/>
                  2. 费用投入产出比达标<br/>
                  3. 业绩达标（回款，门店）<br/>
                  4. 组织团队搭建及培养<br/>
                  5.羊村战略执行落地<br/>
                  6.招募或培养至少2名大区经理
                </td>
              </tr>
            </table>
         </div>
        </div>
      </div>
    </div>
    <div class="module recommend">
      <div class="title">推荐奖励</div>
      <div class="contentWidth clearfix">
        <div class="item">
          <img src="@/assets/images/jiangli_2.png"  width="200"/>
          <p class="detail">
            1.每推荐客户经理200元/人，每多推荐一人，奖励金在上一次基础上多加100，逐次增加
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/jiangli_1.png"  width="200"/>
          <p class="detail">
            1.每推荐区域经理500元/人，每多推荐一人，奖励金在上一次基础上多加100，逐次增加
          </p>
        </div>
      </div>
      <div class="note">注*被推荐人转正成功则视为推荐成功，即可获得推荐奖励金。带考核目标或业务人员考核目标区域内的人员不享受奖金。</div>
    </div>
    <div class="module">
      <v-map></v-map>
    </div>
 </div>
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'
import map from '@/components/map'

export default {
  name: 'cooperation',
  data () {
    return {
      showId: 0,
      activeId: 0,
      tabFixed: false
    }
  },
  components: {
    Slider,
    SliderItem,
    'v-map': map
  },
  methods: {
    tabShow (index) {
      this.showId = index
      this.activeId = index
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.manager{
  .slider {
    width: 100% !important;
    height: 450px !important;
    min-width:1280px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .tabs{
    background-color: #fff;
    width:100%;
    /*&.active{
      position: fixed;
      left: 0;
      top:0;
      padding-top: 38px;
      padding-bottom: 38px;
    }*/
    .contentWidth{
      position: relative;
      height:60px;
      .item{
        position: absolute;
        bottom: -1px;
        width:340px;
        height:60px;
        background: url(../assets/images/biankuang_tab.png) left center no-repeat;
        background-size: cover;
        text-align: center;
        line-height: 60px;
        color: #999;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        &:hover{
           background: url(../assets/images/tingliu_TAB.png) left center no-repeat;
           background-size: cover;
           color: #f95374;
        };
        &.active{
          background: url(../assets/images/xuanzhong_tab.png) left center no-repeat;
          background-size: cover;
          color: #fff;
        }
      }
      .recruitment{
        left:0px;
      }
      .agent{
        left: 384px;
      }
      .partner{
        left: 768px;
      }
    }
  }
  /*.tabContent{
    &.active{
      padding-top: 117px;
    }
  }*/
  .module{
    padding: 88px 0 90px 0;
    &.grow{padding-bottom: 0}
    &>.title{
      text-align: center;
      font-size: 26px;
      color:#333;
      margin-bottom: 52px;
      background: url(../assets/images/line.png) bottom center no-repeat;
      padding-bottom: 22px;
    }
    .tabItem{
      border: 2px dashed #ddd;
      border-radius: 4px;
      padding: 45px 0 40px 0;
      font-size: 16px;
      .fleft{
        width:375px;
        text-align: center;
        line-height: 22px;
        img{
          border-radius: 50%;
        }
        .title{font-size: 20px;padding: 26px 0 20px 0;}
        .info{
          display: inline-block;
          margin-bottom: 22px;
          border:1px solid #ffaf2c;
          border-radius: 25px;
          padding: 2px 30px;
        }
      }
      .fright{
        width: 685px;
        line-height: 30px;
        .title{font-size: 20px;color:#ffaf2c;line-height: 32px; padding-bottom: 15px;}
        .subTitle{font-weight: bold;vertical-align: top;margin-top: 30px;padding-right: 25px;width: 65px;}
        .detail{
          td{padding-top: 12px;}
        }
      }
    }
    &.recommend{
      padding-bottom:64px;
      background-color: #fffbf5;
      text-align: center;
      .item{
        margin: 0 106px;
        width:335px;
        float: left;
        line-height: 26px;
        .detail{
          margin-top: 25px;
        }
      }
      .note{
        color: #666;
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manager.vue